// extracted by mini-css-extract-plugin
module.exports = {"container":"CookieBar_container__5i1v1","title":"CookieBar_title__fwO76","text":"CookieBar_text__PA3yK","buttonContainer":"CookieBar_buttonContainer__ML7_q"};